import React, { useState, useEffect } from "react"

const ManualCourseForm = ({ course, onSubmit, onCancel, isLoading }) => {
  const [name, setName] = useState(course?.name || "")
  const [courseCode, setCourseCode] = useState(course?.course_code || "")
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (course) {
      setName(course.name || "")
      setCourseCode(course.course_code || "")
    }
  }, [course])

  const validate = () => {
    const newErrors = {}
    if (!name.trim()) {
      newErrors.name = "Course name is required"
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (validate()) {
      onSubmit({
        name: name.trim(),
        course_code: courseCode.trim() || null,
      })
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="course-name" className="block text-sm font-medium text-gray-700 mb-1">
          Course Name *
        </label>
        <input
          id="course-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g., Introduction to Psychology"
          className={`
            w-full px-3 py-2 border rounded-lg shadow-sm
            focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500
            ${errors.name ? "border-red-300" : "border-gray-300"}
          `}
          disabled={isLoading}
        />
        {errors.name && (
          <p className="mt-1 text-sm text-red-600">{errors.name}</p>
        )}
      </div>

      <div>
        <label htmlFor="course-code" className="block text-sm font-medium text-gray-700 mb-1">
          Course Code
        </label>
        <input
          id="course-code"
          type="text"
          value={courseCode}
          onChange={(e) => setCourseCode(e.target.value)}
          placeholder="e.g., PSY 101"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          disabled={isLoading}
        />
        <p className="mt-1 text-xs text-gray-500">Optional short code for the course</p>
      </div>

      <div className="flex gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex-1 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50"
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : course ? "Update Course" : "Add Course"}
        </button>
      </div>
    </form>
  )
}

export default ManualCourseForm
